import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Secrets",
  "description": "",
  "published": "2007-01-24T00:00:00.000Z",
  "redirect_from": ["/blog/secrets/swizec/309"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Have a big secret weighing you down? Just want to see some crazy secrets others were willing to share with the internets? Now you can go `}<a parentName="p" {...{
        "href": "http://postsecret.blogspot.com/"
      }}>{`here`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      